import { Component, OnInit } from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { AutenticacionService } from '../services/autenticacion.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { FormGroup, Validators } from '@angular/forms';
import { matchPasswordValidator } from '../validaciones/password-match.validator';
import { Constants } from '../../../constants/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { timer } from 'rxjs';
import { RestablecerContraseniaRequestDto } from '../../../dto/auth/restablecer-contrasenia.request.dto';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-restablecer-contrasenia',
  templateUrl: './restablecer-contrasenia.component.html',
  styleUrl: './restablecer-contrasenia.component.scss',
})
export class RestablecerContraseniaComponent implements OnInit {
  restablecerContrasenaForm: FormField[] = [];
  idUsuario = 0;
  token = '';

  // Multilenguaje
  alertaText: any = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private autenticacionService: AutenticacionService,
    private alertaModalService: AlertaModalService,
    private router: Router,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.translate.stream('password').subscribe(text => {
      this.alertaText = text;
      this.cargarFormulario();
    });
    this.activatedRoute.params.subscribe((params: any) => {
      this.idUsuario = params['usuario-id'];
    });
    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.token = params.get('token');
    });
    this.cargarFormulario();
  }

  cargarFormulario() {
    this.restablecerContrasenaForm = [
      {
        name: 'nuevaContrasena',
        label: this.alertaText['new_password'],
        type: 'password',
        placeholder: this.alertaText['new_password_placeholder'],
        required: true,
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(8),
          Validators.pattern(Constants.REGEX_PASSWORD_VALIDATION_WITH_CHARACTERS),
        ],
        errorMessages: {
          required: this.alertaText['new_password_required'],
          minLenght: this.alertaText['new_password_minLenght'],
          pattern:
            `${this.alertaText['password_info']}
            <ul>
              <li>${this.alertaText['password_mayuscula']}</li>
              <li>${this.alertaText['password_minuscula']}</li>
              <li>${this.alertaText['password_numero']}</li>
              <li>${this.alertaText['password_caracter']}</li>
              <li>${this.alertaText['password_length']}</li>
            </ul>
          `
        },
      },
      {
        name: 'repetirNuevaContrasena',
        label: this.alertaText['repita_new_password'],
        placeholder: this.alertaText['repita_new_password_placeholder'],
        type: 'password',
        required: true,
        width: '12',
        visible: true,
        validation: [matchPasswordValidator('nuevaContrasena')],
        errorMessages: {
          required: this.alertaText['campo_requerido'],
          matchPassword:
          this.alertaText['matchPassword'],
        },
      },
    ];
  }

  onSubmitRestablecerContrasenia(formGroup: FormGroup) {
    const newPassword = formGroup.get('nuevaContrasena')?.value;
    const confirmPassword = formGroup.get('repetirNuevaContrasena')?.value;
    if(newPassword !== confirmPassword) {
      this.alertaModalService.error(
        this.alertaText['titulo_error'],
        this.alertaText['repita_contrasena_matchPassword']
      );
      return;
    }
    const request: RestablecerContraseniaRequestDto = {
      contrasenaNueva: newPassword,
      confirmarNuevaContrasena: confirmPassword,
      token: this.token,
    };
    this.autenticacionService
      .restablecerConstrasenia(this.idUsuario.toString(), request)
      .subscribe({
        next: () => {
          this.alertaModalService.exito(
            'Se restableció la contraseña exitosamente.',
            'Su contraseña ha sido restablecida correctamente'
          );
          timer(3000).subscribe(() => {
            this.redirect();
          });
        },
        error: err => {
          this.alertaModalService.error(
            'Problema restableciendo su contraseña.',
            err.error.message
          );
        },
      });
  }

  redirect() {
    this.router.navigate(['/login']);
  }
}
